import { meta } from '../../global/config/api';
import CHANGELOG from './changelog';

import './styles/footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const CURRENT_YEAR = new Date().getFullYear();

// The version is not a link: the template pointed at /admin/changelog, which
// does not exist here yet. A link that silently redirects lies about what is
// there. It goes back to being a <Link> the day the screen exists.

export default function Footer() {
    return (
        <footer className="footer">
            <span className="footer__name">{meta.projectName}</span>
            <span className="footer__version">{CURRENT_VERSION}</span>
            <span className="footer__copy">
                © {CURRENT_YEAR} · hecho con{' '}
                {/* The heart is decoration; the word it replaces is what a
                    screen reader reads instead, so the sentence still parses. */}
                <span className="footer__heart" aria-hidden="true">♥</span>
                <span className="visually-hidden">amor</span>
                {' '}por Trianametría Software
            </span>
        </footer>
    );
}
